import * as React from 'react';

import { NotificationToast, headerToastNotificationStore } from 'owa-header-toast-notification';
import { observer } from 'mobx-react-lite';
import { NotificationPane, NotificationPaneProps } from 'owa-header-app-notifications';
import { isFeatureEnabled } from 'owa-feature-flags';
import { mergeStyles } from '@uifabric/merge-styles';
import { Layer } from 'office-ui-fabric-react/lib/Layer';

// #24738 - We should move owa-header-toast-notification to owa-header-app-notifications and unify on a design
// For now, this merges the two together.

export default observer(function MergedNotificationPane(props: NotificationPaneProps) {
    if (isFeatureEnabled('fwk-inAppNotifications')) {
        return <NotificationPane {...props}>{getHeaderToasts()}</NotificationPane>;
    } else {
        // This branch will be eliminated once #24738 is addressed and `owa-header-toast-notification` is
        // rolled into `owa-header-app-notifications`.
        return (
            <Layer>
                <div
                    className={mergeStyles({
                        ...props.offset,
                        position: 'absolute',
                    })}>
                    {getHeaderToasts()}
                </div>
            </Layer>
        );
    }
});

function getHeaderToasts() {
    return headerToastNotificationStore.notificationViewStates.map(notification => (
        <NotificationToast notification={notification} key={notification.id} />
    ));
}
